import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { StorefrontRoute } from './guards/StorefrontRoute';
import { StorefrontLayout } from '../features/storefront/views/StorefrontLayout';

const CheckoutView = React.lazy(() => import('../features/storefront/views/order/CheckoutView'));
const OrderSuccessView = React.lazy(
  () => import('../features/storefront/views/order/OrderSuccessView')
);
const OrderCustomerView = React.lazy(
  () => import('../features/storefront/views/order/OrderCustomerView')
);
const StorefrontHomeDispatcher = React.lazy(
  () => import('../features/storefront/dispatcher/StorefrontHomeDispatcher')
);
const WelcomeDiscoveryView = React.lazy(
  () => import('../features/storefront/views/WelcomeDiscoveryView')
);

const SuspenseLoader = () => (
  <div
    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60dvh' }}
  >
    <Spin size="large" tip="Cargando..." />
  </div>
);

export const StorefrontRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/store/:subdomain" element={<StorefrontRoute />}>
        <Route element={<StorefrontLayout />}>
          <Route
            index
            element={
              <Suspense fallback={<SuspenseLoader />}>
                <WelcomeDiscoveryView />
              </Suspense>
            }
          />
          <Route
            path="menu"
            element={
              <Suspense fallback={<SuspenseLoader />}>
                <StorefrontHomeDispatcher />
              </Suspense>
            }
          />
          <Route
            path="checkout"
            element={
              <Suspense fallback={<SuspenseLoader />}>
                <CheckoutView />
              </Suspense>
            }
          />
          <Route
            path="order/:orderId"
            element={
              <Suspense fallback={<SuspenseLoader />}>
                <OrderSuccessView />
              </Suspense>
            }
          />
          <Route
            path="orders"
            element={
              <Suspense fallback={<SuspenseLoader />}>
                <OrderCustomerView />
              </Suspense>
            }
          />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/store/default" replace />} />
    </Routes>
  );
};
export default StorefrontRouter;
